import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';

export function INatCard () {
  return (
      <Card>
        <CardMedia
          component="img"
          height="200"
          image="/img/inat.png"
          alt="inaturalist"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            iNaturalist
          </Typography>
          <Typography>My observations on iNaturalist</Typography>
        </CardContent>
        <CardActions>
          <Button onClick={() => window.location.href = 'https://www.inaturalist.org/observations?user_id=taylordeckard'}>View</Button>
        </CardActions>
      </Card>
  )
}
